import { isLoggedIn } from '/web/store/api'
import { userStore } from '/web/store'
import { A, useNavigate } from '@solidjs/router'
import { CFMark } from './Logo'
import { IconTwitter, IconInstagram, IconFacebook } from './Icons'

export default function Footer() {
  const nav = useNavigate()

  const linkClass = 'block py-1.5 font-rajdhani text-[14px] text-[var(--cf-muted)] transition-colors hover:text-[var(--cf-cyan)]'
  const btnClass = 'block py-1.5 text-left font-rajdhani text-[14px] text-[var(--cf-muted)] transition-colors hover:text-[var(--cf-cyan)]'

  return (
    <footer class="text-[14px] text-[var(--cf-muted)]" style={{ background: 'var(--cf-bg-2)', 'border-top': '1px solid rgba(255,255,255,0.07)' }}>

      {/* Top: logo + name + description — padding: 48px top, 32px bottom */}
      <div
        class="mx-auto flex max-w-[800px] flex-col items-center gap-3 border-b border-[rgba(255,255,255,0.06)] text-center"
        style={{ padding: '48px var(--cf-gutter) 32px' }}
      >
        <CFMark size={48} />
        <h3 class="font-bebas text-[26px] tracking-[1px] text-white">CosplayFans</h3>
        <p class="max-w-[540px] leading-[1.65]">
          CosplayFans powers immersive experiences with your favorite cosplay creators — exclusive content, live chats, and custom AI generated images.
        </p>
      </div>

      {/* Trust strip: padding 18px, margin 8px gutter 0, borders top+bottom */}
      <div
        class="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-b border-t border-[rgba(255,255,255,0.06)]"
        style={{ padding: '18px var(--cf-gutter)', margin: '8px var(--cf-gutter) 0' }}
      >
        {[
          { icon: '🔒', text: 'End-to-End Encrypted Chats' },
          { icon: '💳', text: 'Secure Checkout' },
          { icon: '✓', text: 'Cancel Anytime' },
          { icon: '🛡️', text: 'ASACP Member' },
        ].map((t) => (
          <span class="inline-flex items-center gap-1.5 rounded-full border border-[rgba(255,255,255,0.08)] bg-[rgba(255,255,255,0.04)] px-3 py-[7px] font-rajdhani text-[11.5px] font-bold tracking-[0.6px] text-[rgba(255,255,255,0.75)]">
            <span class="text-xs">{t.icon}</span> {t.text}
          </span>
        ))}
      </div>

      {/* Link columns: padding 40px, max-width 1100px, 2-col mobile / 4-col sm+ */}
      <div
        class="mx-auto grid max-w-[1100px] grid-cols-2 gap-x-6 gap-y-8 border-b border-[rgba(255,255,255,0.06)] sm:grid-cols-4 sm:gap-10"
        style={{ padding: '40px var(--cf-gutter)' }}
      >
        {/* Features */}
        <div>
          <h4 class="mb-4 font-rajdhani text-[13px] font-bold uppercase tracking-[1.5px] text-white">Features</h4>
          <button class={btnClass} onClick={() => { if (!isLoggedIn()) userStore.loginModal(true); else nav('/chat/'); }}>Live Chat</button>
          <button class={btnClass} onClick={() => { if (!isLoggedIn()) userStore.loginModal(true); else nav('/generate-image/'); }}>Generate Image</button>
          <A href="/characters" class={linkClass}>Characters</A>
          {/* #215: "Become a Creator" hidden per Andy — re-add later. Page + route kept intact. */}
          {/* <A href="/become-creator" class={linkClass}>Become a Creator</A> */}
          <A href="/requests" class={linkClass}>Character Requests</A>
        </div>

        {/* Terms */}
        <div>
          <h4 class="mb-4 font-rajdhani text-[13px] font-bold uppercase tracking-[1.5px] text-white">Terms</h4>
          <a href="/terms-of-use/" class={linkClass}>Terms of Use</a>
          <a href="/dmca-policy/" class={linkClass}>DMCA Policy</a>
          <a href="/privacy-policy/" class={linkClass}>Privacy Policy</a>
          <a href="/18-u-s-c-2257-record-keeping-requirements-exemption-statement/" class={linkClass}>2257 Exemption</a>
        </div>

        {/* Contact */}
        <div>
          <h4 class="mb-4 font-rajdhani text-[13px] font-bold uppercase tracking-[1.5px] text-white">Contact</h4>
          <a href="https://www.epoch.com/billing_support/contact" target="_blank" rel="noopener" class={linkClass}>Billing</a>
          <a href="/contact-us/" class={linkClass}>Support</a>
          <a href="/faq/" class={linkClass}>FAQ's</a>
          <a href="/content-removal/" class={linkClass}>Content Removal</a>
        </div>

        {/* Socials */}
        <div>
          <h4 class="mb-4 font-rajdhani text-[13px] font-bold uppercase tracking-[1.5px] text-white">Socials</h4>
          <a href="https://x.com/cosplayfans__" target="_blank" rel="noopener" class={`${linkClass} flex items-center gap-2`}><IconTwitter size={14} /> @cosplayfans_</a>
          <a href="https://www.instagram.com/cosplayfansofficial/" target="_blank" rel="noopener" class={`${linkClass} flex items-center gap-2`}><IconInstagram size={14} /> @cosplayfansofficial</a>
          <a href="https://www.facebook.com/cosplayfansofficial/" target="_blank" rel="noopener" class={`${linkClass} flex items-center gap-2`}><IconFacebook size={14} /> @cosplayfansofficial</a>
          <a href="/blog" class={linkClass}>Blog</a>
        </div>
      </div>

      {/* Bottom: padding 18px, payment marks height 22px + copyright */}
      <div
        class="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-center sm:gap-[18px]"
        style={{ padding: '18px var(--cf-gutter)' }}
      >
        <div class="flex items-center gap-2">
          <img src="/images/footer/visa-card.svg" alt="Visa" style={{ height: '22px', width: 'auto' }} class="rounded" />
          <img src="/images/footer/mastercard-card.svg" alt="Mastercard" style={{ height: '22px', width: 'auto' }} class="rounded" />
          <img src="/images/footer/discover-card.svg" alt="Discover" style={{ height: '22px', width: 'auto' }} class="rounded" />
        </div>
        <span class="font-rajdhani text-[12px] text-[rgba(255,255,255,0.3)]">
          © 2026 CosplayFans. All rights reserved.
        </span>
      </div>
    </footer>
  )
}
